module.exports = __webpack_public_path__ + "img/JodyAvirgan.59a41008.webp";